<!--
 * @Author       : 花裤衩<白永明><yongming.bai@outlook.com>
 * @Date         : 2026-07-01 16:01:01 +0800
 * @LastEditors  : 花裤衩<白永明><yongming.bai@outlook.com>
 * @LastEditTime : 2026-07-17 15:24:41 +0800
 * @FilePath     : /ai-agent-lumina/src/components/global/album/src/izt-album.vue
 * @Description  : 图册
-->
<style lang="scss" scoped>
@use "sass:map";

$size-map: (
  small: (gap: 16px, item: 120px, radius: 16px),
  medium: (gap: 20px, item: 160px, radius: 20px),
  large: (gap: 24px, item: 198px, radius: 24px),
);

.izt-album-container {
  .izt-album-list {
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
    &::-webkit-scrollbar {
      display: none;
    }
    @each $name, $conf in $size-map {
      &.#{$name}-content {
        gap: map.get($conf, gap);
      }
    }
    .izt-album-item {
      overflow: hidden;
      flex-shrink: 0;
      &.clickable {
        cursor: pointer;
      }
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      @each $name, $conf in $size-map {
        &.#{$name} {
          width: map.get($conf, item);
          height: map.get($conf, item);
          border-radius: map.get($conf, radius);
        }
      }
    }
  }
}
</style>

<template>
  <div class="izt-album-container " :class="className">
    <div :class="['izt-album-list', `${size}-content`]">
      <div :class="['izt-album-item', size, { clickable: preview }]" v-for="(src, index) in list" :key="index" @click.stop="handleClick(index)">
        <img v-img-src="src">
      </div>
    </div>
  </div>
  <van-image-preview  @click.stop v-if="preview" v-model:show="showPreview" :images="previewImages" :start-position="currentIdx" closeable />
</template>

<script setup name="izt-album">
  import { ref, computed } from 'vue'
  import { ImagePreview as VanImagePreview } from 'vant'
  import 'vant/es/image-preview/style'

  defineOptions({ name: 'izt-album' })
  const props = defineProps({
    list: {
      type: Array,
      default: () => []
    },
    size: {
      type: String,
      default: 'small' // 'small' | 'medium' | 'large'
    },
    className: {
      type: String,
      default: ''
    },
    preview: {
      type: Boolean,
      default: false // 是否开启点击预览大图
    }
  })

  const showPreview = ref(false)
  const currentIdx = ref(0)
  const previewImages = computed(() => props.list.map(src => src))

  const handleClick = (index) => {
    if (!props.preview) return
    currentIdx.value = index
    showPreview.value = true
  };
</script>